export default "__VITE_ASSET__DAyxDaSV__"